import * as React from 'react'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const IEWarning = () => {
    return <Grid container direction="column" justify="center" alignItems="center">
        <Grid item><br /></Grid>
        <Grid item><Typography paragraph>Tämä sovellus ei tue Internet Explorer-selainta.</Typography></Grid>

        <Grid item><Typography paragraph>Suosittelemme käyttämään Chrome, Firefox tai Edge selainta.</Typography></Grid>
    </Grid>
}

export default IEWarning;


// WEBPACK FOOTER //
// ./src/common/IEWarning.tsx